// extracted by mini-css-extract-plugin
module.exports = {"spaceWrapper":"AffiliateCommissionsReportTable_spaceWrapper__1-K1T","streamList":"AffiliateCommissionsReportTable_streamList__1yMEA"};